import React from "react";
import ActivityActionBar from "components/activities/activityActionBar";
import "./activities.scss";
import { useTranslation } from "react-i18next";
const Activities = () => {
  const { t } = useTranslation();
  return (
    <div className="activity">
      <div className="custom-breadcrumbs ">
        <span className="breadcrumbs-item ">{t("activity")}</span>
      </div>
      <ActivityActionBar />
    </div>
  );
};

export default Activities;
